<template>
  <Landing>
    <Reg1 v-show="step == 1" @to-reg-step2="nextStep" :isNew="isNew" :form="form"></Reg1>
    <Reg2 v-show="step == 2" @ready-to-get-code="getAuthCode" @ready-to-submit="submit" @to-reg-step1="lastStep" :isNew="isNew" :form="form"></Reg2>
  </Landing>
</template>
<script>
import Landing from '@/page/byl/landing.vue'
import Reg1 from '@/components/common/org-reg/reg1.vue'
import Reg2 from '@/components/common/org-reg/reg2.vue'
import utils from '@/utils'
import { mapState, mapActions } from 'vuex'
import config from '@/config'
import api from '@/api'
export default {
  components: { Landing, Reg1, Reg2 },
  data () {
    return {
      step: '1',
      form: {}
    }
  },
  methods: {
    ...mapActions('auth', {
      getCode: 'getCode',
      updates: 'updates',
      getOrgs: 'getOrgs'
    }),
    nextStep () {
      this.step = '2'
    },
    lastStep () {
      this.step = '1'
    },
    getAuthCode (phone) {
      if (phone && phone !== (null || undefined || '')) {
        this.getCode(phone)
      }
    },
    submit () {
      var that = this
      // isNew: true表示未登录情况下注册, false表示已登录情况下注册
      if (that.isNew == true) { this.form.loginType = '2' }
      api.post(config.bylApiPath, '/entInfo/save', this.form, function (r) { // 正常
        if (r.data) { // 非登录状态下注册机构的情况
          var user = r.data.user
          var token = r.data.token
          that.updates({token: token, user: user}) // 更新一下登录的状态，主要就是在cookie里update一下token
        } else { // 已登录状态下注册机构
          //
        }
        that.$toasted.show('注册机构成功')
        /* if (utils.getQueryString('h')) {
          window.location.href = window.location.origin + '/' + utils.getQueryString('h')
        } else { */
        that.toOtherDomain(that.form.businessIdList)
        // }
      })
    },
    toOtherDomain (businessId) {
      var dev = false;
      if (window.location.hostname == 'localhost') {
        dev = true;
      }
      if (dev) { // 开发状态下用vue router路由
        if (businessId == '1') { // 职称教育
          this.$router.push({path: '/continueEdu/home'})
        } else if (businessId == '2') { // 安全教育
          this.$router.push({path: '/byl/index'})
        } else if (businessId == '3') { // 企业内训
          this.$router.push({path: '/entrain/home'})
        } else if (businessId == '4') { // 党建教育
          this.$router.push({path: '/byl/index'})
        } else {
          this.$router.push({path: '/byl/index'})
        }
      } else {
        if (businessId == '1') { // 职称教育
          window.location.href = window.location.origin + '/#/continueEdu/home'
        } else if (businessId == '2') { // 安全教育
          window.location.href = window.location.origin + '/#/byl/index'
        } else if (businessId == '3') { // 企业内训
          window.location.href = window.location.origin + '/#/entrain/home'
        } else if (businessId == '4') { // 党建教育
          window.location.href = window.location.origin + '/#/byl/index'
        }
      }
    }
  },
  computed: {
    ...mapState('auth', ['token', 'user']),
    isNew () {
      return !this.token
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/byl/auth/org-reg-page.vue